"use strict";

var questions = [{
  prompt: "A copy of your responses will be sent to your coach. You’ll also be able to see a copy yourself here in the Uprise app.",
  type: "multi",
  options: [],
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, {
  prompt: "",
  extraText: "Write down the Solution you attempted",
  placeholder: "",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Write down your whether your predictions about what would happen were correct or not",
  placeholder: "",
  type: "multirow",
  aggregated: true
}];
var complete = "Thanks for completing the exercise. A copy of what you’ve written will be available to view shortly and we’ll send your responses to your coach as well.";

var analysis = function analysis(answers) {
  return {
    answer1: answers[1],
    answer2: answers[2]
  };
};

module.exports = {
  questions: questions,
  complete: complete,
  analysis: analysis
};